module.exports = __webpack_public_path__ + "img/logo.c97aec15.png";